import { Event } from '../types';

export class BridgeDataChanged extends Event<{
  oldContentId: string;
  newContentId: string;
}> {}
